import { render, staticRenderFns } from "./Plugin123Chat.vue?vue&type=template&id=c93e4e28"
import script from "./Plugin123Chat.vue?vue&type=script&lang=js"
export * from "./Plugin123Chat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c93e4e28')) {
      api.createRecord('c93e4e28', component.options)
    } else {
      api.reload('c93e4e28', component.options)
    }
    module.hot.accept("./Plugin123Chat.vue?vue&type=template&id=c93e4e28", function () {
      api.rerender('c93e4e28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/plugins/Plugin123Chat.vue"
export default component.exports